import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ConfigService } from './config.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WebSocketServerService {
  private ws: WebSocket;
  private readonly messages$ = new Subject<string>();

  constructor(private readonly configService: ConfigService) {
    this.connect();
  }

  private connect(): void {
    this.ws = new WebSocket(this.configService.config.websocketUrl);

    this.ws.onmessage = event => {
      this.messages$.next(event.data);
    };

    this.ws.onclose = () => {
      setTimeout(() => this.connect(), 5000);
    };

    this.ws.onerror = error => console.error('WebSocket error:', error);
  }

  public send(message: any): void {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(message));
    } else {
      console.error('WebSocket is not connected.');
    }
  }

  public onMessage<T>(filterType: string): Observable<T> {
    return this.messages$.asObservable().pipe(
      map(msg => {
        const data = JSON.parse(msg);
        if (data.type === filterType) {
          return data.payload as T;
        }
        throw new Error('Ignored message type');
      })
    );
  }
}
